export const CURRENT_PROMOTION: Promotion | undefined = {
  discount: 0.25,
  coupon: 'EARLYBIRD',
  before: 'October 15th, 2025'
}

export function formatDiscount(discount: number) {
  return Math.round(discount * 100).toString() + '%'
}

export type Promotion = {
  // The discount that will be applied to the purchase
  // For example, 0.20 means 20% off
  discount: number

  // The date until which the promotion is valid
  // This would show up in a banner with a message like:
  // Get 20% off all credits purchased before October 1st, 2025.
  // Can be a human readable date
  before: string

  // The coupon code that will be applied to the purchase
  // For example, "SUMMER2025"
  coupon: string
}

export const NUMBER_OF_CREDITS_OPTIONS: number[] = [
  10, 25, 50, 100, 150, 200, 300, 400, 500, 600, 700, 800, 900, 1000, 1500, 2000, 3000, 4000, 5000,
  6000, 7000, 8000, 9000, 10000
]
